import { render, staticRenderFns } from "./SingleBanned.vue?vue&type=template&id=566bfd60"
import script from "./SingleBanned.vue?vue&type=script&lang=js"
export * from "./SingleBanned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports